import { render, staticRenderFns } from "./MatterMonitoringSurveillanceForm.vue?vue&type=template&id=15f0357a&"
import script from "./MatterMonitoringSurveillanceForm.vue?vue&type=script&lang=js&"
export * from "./MatterMonitoringSurveillanceForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterMonitoringSurveillanceForm.vue?vue&type=style&index=0&id=15f0357a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports